import api from "common/api";
import "./LoginPage.css";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAuth } from "authContext";
import usePageTitle from "common/usePageTitle";

function LoginPage() {
  const [email, setEmail] = useState<string | null>(null);
  const [password, setPassword] = useState<string | null>(null);

  const navigate = useNavigate();

  const { login } = useAuth();

  usePageTitle("Login");

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();

    try {
      const response = await api.post(
        "accounts/jwt/create/",
        { email: email, password: password },
        { skipRefreshToken: true },
      );
      login(response.data.access);

      localStorage.setItem("refreshToken", response.data.refresh);

      navigate("/dashboard");
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        toast.error("Neispravni podaci za prijavu");
      } else {
        toast.error("Dogodila se greška");
      }
    }
  };

  return (
    <Row
      className="d-flex justify-content-center align-items-center"
      style={{ height: "95vh" }}
    >
      <Col md={8} lg={6} xs={12}>
        <div className="border border-2 border-primary"></div>
        <Card className="shadow px-4">
          <Card.Body>
            <div className="mb-3 mt-md-4">
              <h2 className="fw-bold mb-2 text-center text-uppercase ">
                Lumen@home Prijava
              </h2>
              <ul>
                <li>
                  Ukoliko želite prijavu na pripreme državne mature možete
                  ispuniti{" "}
                  <Link to="/prijava-pripreme-drzavna-matura">prijavnicu</Link>{" "}
                </li>
                <li>
                  Za rezervaciju poduka možete slijedite poveznicu:{" "}
                  <Link to="/poduke/rezervacija">Rezervacija poduka</Link>
                </li>
              </ul>
              <div className="mb-3">
                <Form>
                  <Form.Group className="mb-3" controlId="formGroupEmail">
                    <Form.Label>Email adresa</Form.Label>
                    <Form.Control
                      required
                      type="email"
                      placeholder="Unesite email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formGroupPassword">
                    <Form.Label>Lozinka</Form.Label>
                    <Form.Control
                      required
                      type="password"
                      placeholder="Unesite lozinku"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>
                  <p className="mb-3">
                    <Link
                      to="/zaboravljena-lozinka"
                      className="text-primary fw-bold"
                    >
                      Zaboravljena lozinka?
                    </Link>
                  </p>

                  <div className="d-grid">
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Prijavi me
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default LoginPage;
